import { render } from "./investmentCompanyDetail.vue?vue&type=template&id=85001c5a&scoped=true"
import script from "./investmentCompanyDetail.vue?vue&type=script&lang=js"
export * from "./investmentCompanyDetail.vue?vue&type=script&lang=js"

import "./investmentCompanyDetail.vue?vue&type=style&index=0&id=85001c5a&scoped=true&lang=css"

import exportComponent from "D:\\code\\vue\\gaoxinTech\\gaoxin_tech1\\gaoxintech\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85001c5a"]])

export default __exports__